import { Chapter } from "../../../models/chapter";
import { LanguageCourse } from "../../../models/languageCourse";

/**
 * Pure functions for duration math — the single definition.
 *
 * Context: the original codebase had THREE formulas:
 *   1. calculateTotalDurationOnLanguageCourse: sum of chapter.duration
 *   2. completeDataCourse: sum of __fileVideo.duration + quiz question timers
 *   3. CourseService.calculateDuration (persistence layer): sum of chapter.duration
 *
 * Since the persistence layer (CourseService.save) treats chapter.duration as
 * the source of truth, we align with it: chapter.duration when set, with the
 * video + quiz formula only as a fallback for chapters that never had their
 * duration field populated.
 */

export function calculateChaptersDuration(chapters: Chapter[] | null | undefined): number {
	return (chapters ?? []).reduce((total, chapter) => total + chapterDuration(chapter), 0);
}

export function chapterDuration(chapter: Chapter | null | undefined): number {
	if (!chapter) { return 0; }

	if (chapter.duration != null) {
		return chapter.duration;
	}

	// Fallback: derive from the attached media + quiz timers.
	const videoDuration = chapter.__fileVideo?.duration ?? 0;
	const quizDuration = (chapter.quiz?.questions ?? [])
		.reduce((sum, q) => sum + (q.timer ?? 0), 0);

	return videoDuration + quizDuration;
}

export function applyDurations(languageCourses: LanguageCourse[]): void {
	(languageCourses ?? []).forEach(lc => {
		lc.duration = calculateChaptersDuration(lc.chapters);
	});
}
